import React from 'react';
import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';
import reset from 'styled-reset';
import MainScreen from './screen/MainScreen';
import mediaQ from './theme/responsive.js';

import GROTESKLight from './theme/fonts/grotesk/AktivGroteskGeberit_W_Lt.ttf';
import GROTESKRegular from './theme/fonts/grotesk/AktivGroteskGeberit_W_Rg.ttf';
import GROTESKMedium from './theme/fonts/grotesk/AktivGroteskGeberit_W_Md.ttf';
import GROTESKBold from './theme/fonts/grotesk/AktivGroteskGeberit_W_Bd.ttf';
import geberitWeb20IconFont from './theme/fonts/icons/geberitWeb20IconFont.ttf';
import ComponentToPrintNew from './components/ComponentToPrintNew';

const GlobalStyle = createGlobalStyle`
    ${reset}
    
    @font-face {
        font-family: GROTESK Light;
        src: url(${GROTESKLight}) format('opentype');
        font-weight: 200;
        font-style: normal;
    }
        
    @font-face {
        font-family: GROTESK Regular;
        src: url(${GROTESKRegular}) format('opentype');
        font-weight: 400;
        font-style: normal;
    }
        
    @font-face {
        font-family: GROTESK Bold;
        src: url(${GROTESKBold}) format('opentype');
        font-weight: 700;
        font-style: normal;
    }
        
    @font-face {
        font-family: GROTESK Medium;
        src: url(${GROTESKMedium}) format('opentype');
        font-weight: 600;
        font-style: normal;
    }
    @font-face {
        font-family: geberitWeb20IconFont;
        src:  url(${geberitWeb20IconFont}) format('opentype');
        font-weight: 700;
        font-style: normal;
      }
    
    html, body {
        height: 100%;
        width: 100%;
        background-color: #FFFFFF
        font-family: GROTESK Regular;
        font-size: 15px;
        line-height: 1;

        ${mediaQ.tablet`
            font-size: 15px;
        `}

        ${mediaQ.phone`
            font-size: 15px;
        `}
    }

    @media (max-width: 700px) {
        html, body {
            font-size: 15px;
        }
    }
    
    h1 {
        font-family: GROTESK Light
        font-size: 3rem;
        padding: 8rem 0 4rem 0;
        width: 100%;
    }
    
    h2 {
        font-family: GROTESK Bold
        font-size: 1.3rem;
        line-height: 2rem;
        margin: 0 0 1.3rem;
        width: 100%;
    }
    
    h3 {
        font-family: GROTESK Bold
        font-size: 1rem;
        width: 100%;
    }
    
    * {
        box-sizing: border-box;
    }
    
    b {
        font-family: GROTESK Bold;
    }

    sub {
        font-size: .6rem;
        bottom: -.25em;
        position: relative;
    }
    sup{
        font-size: .6rem;
        bottom: 0.5em;
        position: relative;
    }

    .overlined {
        border-top: 1px solid black;
        margin-right: 5px;
    }
    .spaceRight{
        margin-right: 5px;
    }
    .FullWidth{
        width:100%;
        height:1080px;
    }
`;

export default () => (
  
    <React.Fragment>
        <GlobalStyle />
        <MainScreen />
    </React.Fragment>
);
